<template>
  <div>
    <button type="button" class="btn btn-primary btn-with-addon" @click="showModal">
      <span class="btn-addon">
        <i class="btn-addon-icon fe fe-plus-circle" />
      </span>
      Add Bundled Product
    </button>

    <a-modal v-model="visible" title="Add New Bundled Product">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Close</a-button>
        <a-button key="submit" type="primary" htmlType="submit" :loading="loading" @click="savedata">Submit</a-button>
      </template>

      <a-form class="mb-4" :form="form">
        <a-form-item label="Name">
          <a-input placeholder="Bundled Product Name" v-decorator="[
            'name',
            {
              rules: [
                {
                  required: true,
                  message: 'Please input bundled product name!',
                },
                { max: 30, message: 'Must not exceed 30 characters!' },
              ],
            },
          ]" />
        </a-form-item>
        <a-form-item label="Bundled Product Code">
          <a-input placeholder="Bundled Product Code. eg: SKU1129930" v-decorator="[
            'code',
            {
              rules: [
                {
                  required: true,
                  message: 'Please input bundled product code!',
                },
                { max: 30, message: 'Must not exceed 30 characters!' },
              ],
            },
          ]" />
        </a-form-item>

        <a-form-item label="Description">
          <a-textarea placeholder="Description" :autosize="{ minRows: 2 }" v-decorator="[
            'description',
            {
              rules: [
                { max: 100, message: 'Must not exceed 100 characters!' },
              ],
            },
          ]" />
        </a-form-item>

        <div class="mt-3">
          <p class="text-uppercase font-weight-bold text-muted">
            Products
          </p>

          <div class="row mb-4">
            <div class="col-12" v-for="(key, index) in productGroupings" :key="key">
              <div class="d-flex">
                <div class="mr-2 pt-2">
                  <span class="font-weight-bold">{{ index + 1 }}.</span>
                </div>

<!--                <div class="col">-->
<!--                  <a-form-item>-->
<!--                    <a-input placeholder="{{products.code}}" v-decorator="['code',]" />-->
<!--                  </a-form-item>-->
<!--                </div>-->

                <div class="col">
                  <a-form-item>
                    <a-select style="width: 100%" v-decorator="[
                      `product_group[${key - 1}]`,
                      {
                        rules: [
                          {
                            required: true,
                            message: 'Please select a Product!',
                          },
                        ],
                        initialValue: [],
                      },
                    ]" placeholder="Select a product">
                      <a-select-option v-for="product in products" :key="product.id">
                        {{ product.name }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </div>

                <div class="col">
                  <a-form-item>
                    <a-input-number
                      style="width: 100%"
                      placeholder="Add Quantity"
                      v-decorator="[`quantity[${key - 1}]`, {rules: [{ required: true, message: 'Please input quantity!' }]}]"
                    />
                  </a-form-item>
                </div>

                <div class="ml-2 pt-1">
                  <button class="btn btn-sm btn-danger" @click.prevent="handleRemoveProductGrouping(key)">
                    <i class="btn-addon-icon fe fe-trash-2" />
                  </button>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="add-button">
                <button class="add-prod" @click.prevent="handleAddProductGrouping">
                  + Add products
                </button>
              </div>
            </div>
          </div>
        </div>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { fetchInventoryData } from '@/components/inventory/common'
export default {
  name: 'newBundledProduct',
  props: {
    formVisible: { type: Boolean, require: true },
  },
  data: function () {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      categories: [],
      productGroupings: [],
      productCounter: 0,
      productGroups: [],
      prodGroupSpinning: false,
    }
  },
  mounted: function () {
    let d = fetchInventoryData('category')
    d.then((data) => {
      this.categories = data.data
    }).catch((err) => console.error(err))

    this.getProducts()
  },
  watch: {
    formVisible: function (n, o) {
      // console.log('formvisible changed??', n)
      this.visible = n
    },
  },
  methods: {
    getProducts: function () {
      this.$http
        .get('/api/inventory/product')
        .then(({ data }) => {
          this.products = data.data
        })
        .catch((error) => {
          console.log(error)
        })
    },
    handleAddProductGrouping() {
      this.productCounter++
      if (this.productGroupings.length < 10) {
        this.productGroupings.push(this.productCounter)
      }
    },
    handleRemoveProductGrouping(key) {
      this.$confirm({
        title: `Are you sure?`,
        content: `Click Ok to remove this product grouping.`,
        onOk: () => {
          this.productGroupings = this.productGroupings.filter(
            (item) => item !== key
          )
        },
        onCancel: () => {
          this.loading = false
        },
      })
    },
    showModal() {
      this.visible = true
    },
    savedata: function () {
      this.loading = true
      this.form.validateFields((err, values) => {
        console.log('Null', values.product_group)
        if (!err) {
          // clearform(this.form)
          this.$confirm({
            title: `Are you sure you want to add ${values.name}?`,
            content: `Click on the OK button to add the new product!`,
            onOk: () => {
              this.$http
                .post('/api/inventory/bundled_product', {
                  name: values.name,
                  code: values.code,
                  description: values.description,
                  remark: '',
                  status: 1,
                  product_id: values.product_group,
                  quantity: values.quantity,
                })
                .then((resp) => {
                  this.$emit('created')
                  this.loading = false
                  this.visible = false
                  if (resp.status === 200) {
                    this.$notification['success']({
                      message: 'Bundled Product created successfully',
                      description: `${values.name} added successfully!`,
                    })
                  } else {
                    this.$notification['warning']({
                      message: 'Unknown Error',
                      description: `There appears to be an error while submitting data. Response from server: ${resp.status} ${resp.message}`,
                    })
                  }
                  this.form.resetFields()
                })
                .catch((err) => {
                  this.loading = false
                  this.$neoNotify.error(err)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }

        this.loading = false
      })
    },
    handleCancel(e) {
      this.visible = false
    },
  },
}
</script>

<style>
.add-button {
  display:flex;
  justify-content: center;
}
.add-prod {
  background: none;
  border: 1px dashed grey;
  width: 20rem;
  margin-top: 5px;
}
.add-prod:focus {
  outline: none;
}
</style>
